import { render, staticRenderFns } from "./HeaderStatus.vue?vue&type=template&id=6f545b4d&scoped=true&"
import script from "./HeaderStatus.vue?vue&type=script&lang=ts&"
export * from "./HeaderStatus.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderStatus.vue?vue&type=style&index=0&id=6f545b4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f545b4d",
  null
  
)

export default component.exports